import { NonAppNavWrapper } from '@/components/generic/non-app-nav'
import type { NextPage } from 'next'
import { NextSeo } from 'next-seo'

const PrivacyPolicy: NextPage = () => {
  return (
    <>
      <NextSeo
        title="v0.report AI - Privacy Policy"
        description="Learn how v0.report collects, uses, and protects your data."
      />
      <NonAppNavWrapper>
        <div className="bg-white rounded-lg">
          <div className="p-6 container mx-auto pt-10">
            <h1 className="text-3xl font-bold">v0.report Privacy Policy</h1>
            <p className="text-gray-500">Effective Date: September 23, 2023</p>

            <div className="divider"></div>

            <p>
              This Privacy Policy describes how v0.report ("we," "us," or "our") collects, uses, and
              discloses your personal information when you use our website and services
              ("Services").
            </p>

            <h2 className="pt-2 font-bold">Information We Collect</h2>

            <p>We may collect the following information when you use our Services:</p>

            <ul>
              <li>
                Personal information you provide directly, such as your name and email address (if
                you choose to create an account).
              </li>
              <li>
                Information collected automatically, such as your IP address, browser type, and
                device information.
              </li>
              <li>Information collected from cookies and similar technologies.</li>
            </ul>

            <h2 className="pt-2 font-bold">How We Use Your Information</h2>

            <p>We may use your information for the following purposes:</p>

            <ul>
              <li>To provide and improve our Services.</li>
              <li>To personalize your experience.</li>
              <li>To send you marketing communications (if you consent).</li>
              <li>To analyze how you use our Services.</li>
              <li>To comply with legal obligations.</li>
            </ul>

            <h2 className="pt-2 font-bold">Your Choices</h2>

            <p>
              You have choices regarding your information. You can:
              <ul>
                <li>Access and update your information.</li>
                <li>Opt out of marketing communications.</li>
              </ul>
            </p>

            <h2 className="pt-2 font-bold">Data Retention</h2>

            <p>
              We will retain your information for as long as necessary to provide the Services,
              comply with legal obligations, or resolve disputes.
            </p>

            <h2 className="pt-2 font-bold">Security</h2>

            <p>
              We take reasonable steps to protect your information from unauthorized access,
              disclosure, alteration, or destruction. However, no internet transmission or
              electronic storage is ever 100% secure.
            </p>

            <h2 className="pt-2 font-bold">Children's Privacy</h2>

            <p>
              Our Services are not directed to children under 13. We do not knowingly collect
              personal information from children under 13. If you are a parent or guardian and you
              believe your child has provided us with personal information, please contact us.
            </p>

            <h2 className="pt-2 font-bold">Changes to This Privacy Policy</h2>

            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes
              by posting the new Privacy Policy on this page.
            </p>

            <h2 className="pt-2 font-bold">Contact Us</h2>

            <p>
              If you have any questions about this Privacy Policy, please contact us at
              team@v0.report.
            </p>
          </div>
        </div>
      </NonAppNavWrapper>
    </>
  )
}

export default PrivacyPolicy
